import pulseConfig from "@/pulsex.config";
import { MangoBlockProps } from "@/types/general";
import { useLoadMore } from "@pulsex/hooks";
import { cn } from "@pulsex/utils";
import ImageUI from "../CustomImage/ImageUI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { Author, Post } from "@pulsex/types";
import Link from "next/link";

export default function AuthorWork({ block }: MangoBlockProps) {
    const widget = block?.getMainWidget();

    if (!widget || !widget?.posts) return;
    const post = widget.posts[0];
    return (
        <section className={cn("container mx-auto my-5")}>
            <AuthorDetailsView authorPost={post} className="col-span-2"/>
        </section>
    );
}


export function AuthorDetailsView({authorPost, className}: {authorPost: Post, className?: string}){
    return <div className="grid grid-cols-12 gap-8 items-center lg:grid-cols-1 lg:items-start sm:gap-3">
    <div className={cn('col-span-2 sm:w-24', className)}>
        <ImageUI
            data={authorPost}
            cropSize={"square"}
            className="rounded-full object-cover bg-transparent w-full"
        />
    </div>
    <div className="col-span-10">
        <Link href={`${authorPost.url}`} className="text-3xl dark:text-white block font-bold mb-2 transition hover:text-primary">
            {authorPost?.title}
        </Link>
        <p className="text-gray-600 mb-3 dark:text-gray-400">{authorPost?.summary}</p>
        <div className="flex gap-4">
            {/* This to get all metas without accessing the metas property */}
            {authorPost?.filterMetas((m) => !!m)?.map(
                (socialMedia, index) => (
                    <a
                        key={index}
                        href={socialMedia.value}
                        title={socialMedia.title}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        {getSocialIcon(socialMedia.key)}
                    </a>
                )
            )}
        </div>
    </div>
</div>
}


function getSocialIcon(platform:string) {
  switch (platform) {
    case "twitter":
      return <FontAwesomeIcon icon={faXTwitter}/>
  }

}